import styled from "styled-components";
import { desktopRightContainerWidth } from "@utils/index";

export const Page = styled.div`
  min-height: 100%;
  background: #ffffff;
  color: #121212;
  font-family: "Euclid Circular B", sans-serif;

  @media (min-width: 1024px) {
    background: #f8f7fc;
  }
`;

export const DesktopHeader = styled.header`
  display: none;

  @media (min-width: 1024px) {
    width: 100%;
    display: block;
    background: #ffffff;
  }
`;

export const DesktopBody = styled.div`
  width: 100%;

  @media (min-width: 1024px) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    background: #f8f7fc;
    padding: 32px 0 0;
    min-height: calc(100vh - 100px);
    height: max-content;
  }
`;

export const DesktopProgress = styled.aside`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    width: 20%;
    height: max-content;
    position: sticky;
    top: 50px;
  }
`;

export const Shell = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0 auto;
  display: flex;
  background: #ffffff;
  flex-direction: column;

  @media (min-width: 768px) {
    max-width: 360px;
    box-shadow: 0 12px 40px rgba(4, 2, 34, 0.08);
  }

  @media (min-width: 1024px) {
    width: ${desktopRightContainerWidth};
    max-width: ${desktopRightContainerWidth};
    min-height: auto;
    overflow: hidden;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #efe9fb;
    box-shadow: none;
    margin: 0;
    margin-bottom: 140px;
  }
`;

export const TopSection = styled.section`
  flex: 0 0 auto;
  padding: 0 20px 40px;

  @media (min-width: 1024px) {
    padding: 31px 32px 32px;
  }
`;

export const Nav = styled.div`
  padding: 13px 0;
  display: flex;
  align-items: center;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const BackButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  display: flex;
  cursor: pointer;
  background: transparent;
  align-items: center;
  justify-content: flex-start;
`;

export const PlansAvailable = styled.div`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  background: linear-gradient(253deg, #f16262 63.25%, #743ddc 103.61%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (min-width: 1024px) {
    margin-top: 0;
  }
`;

export const InsuranceHeading = styled.h1`
  margin: 12px 0 24px;
  color: #121212;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;

  @media (min-width: 1024px) {
    margin: 8px 0 25px;
    color: #040222;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  border: 0;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border-radius: 12px;
  background: #0fa457;
`;

export const DriveSection = styled.section`
  flex: 1 0 auto;
  padding: 32px 20px;
  background: #f8f7fc;

  @media (min-width: 1024px) {
    padding: 32px;
  }
`;

export const Logo = styled.img`
  width: 120px;
  height: auto;
  display: block;

  @media (min-width: 1024px) {
    width: 122px;
  }
`;

export const DriveHeading = styled.h2`
  margin: 16px 0 24px;
  color: #121212;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;

  @media (min-width: 1024px) {
    margin: 12px 0 20px;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const SavingsCard = styled.div`
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e7e7f0;
  padding: 12px 12px 16px 12px;

  @media (min-width: 1024px) {
    padding: 12px 18px 18px;
  }
`;

export const HeroVisual = styled.div`
  height: 120px;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: radial-gradient(circle at center, #e6e4f1 0, #f8f7fc 72%);

  @media (min-width: 1024px) {
    height: 136px;
    border-radius: 12px;
  }
`;

export const CarBackground = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const CarImage = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 188px;
  max-height: 68px;
  object-fit: contain;
  transform: translate(-50%, -50%);

  @media (min-width: 1024px) {
    width: 181px;
    max-height: 91px;
  }
`;

export const Copy = styled.p`
  margin: 18px 4px 16px;
  color: #4b4b4b;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  @media (min-width: 1024px) {
    margin: 16px 0;
  }

  strong {
    color: #121212;
    font-weight: 500;
  }

  span {
    color: #0fa457;
    font-weight: 500;
  }
`;

export const PriceComparison = styled.div`
  height: 70px;
  display: grid;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e0ede3;
  background: linear-gradient(180deg, #ffffff 0%, #ebfbee 100%);
`;

export const PriceColumn = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const PriceLabel = styled.div<{ green?: boolean }>`
  color: ${({ green }) => (green ? "#0b753e" : "#757575")};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const PriceValue = styled.div`
  color: #121212;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const Vs = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  color: #121212;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  border-radius: 50%;
  align-items: center;
  background: #f5f5f5;
  justify-content: center;
  transform: translate(-50%, -50%);

  &::before {
    content: "";
    position: absolute;
    z-index: -1;
    width: 1px;
    height: 46px;
    background: #e0ede3;
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  height: 48px;
  margin-top: 20px;
  color: #121212;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #121212;
`;
